import { unref as _unref, toDisplayString as _toDisplayString, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, createElementVNode as _createElementVNode, createVNode as _createVNode, mergeProps as _mergeProps, withCtx as _withCtx, renderList as _renderList, Fragment as _Fragment, normalizeClass as _normalizeClass, createBlock as _createBlock, normalizeStyle as _normalizeStyle, Transition as _Transition, Teleport as _Teleport } from "vue"

const _hoisted_1 = ["for"]
const _hoisted_2 = { class: "relative" }
const _hoisted_3 = { class: "block truncate" }
const _hoisted_4 = { class: "pointer-events-none absolute inset-y-0 right-0 flex items-center pr-2" }
const _hoisted_5 = ["id"]

import { Listbox, ListboxButton, ListboxOption, ListboxOptions } from '@headlessui/vue'
import { CheckIcon, ChevronUpDownIcon } from '@heroicons/vue/20/solid'
import { ulid } from 'ulid'
import { computed } from 'vue'

import { useDropdownAnchor } from '@/composables/useDropdownAnchor'

export default /*@__PURE__*/Object.assign({
  inheritAttrs: false
}, {
  __name: 'SelectInput',
  props: ['modelValue', 'name', 'description', 'options', 'placeholder', 'slim', 'pill', 'disabled'],
  emits: ['update:modelValue', 'change', 'input'],
  setup(__props, { emit: __emit }) {

const id = ulid()



const { setReference, setFloating, floatingStyles } = useDropdownAnchor({ matchReferenceWidth: true, maxHeight: 240 })

const props = __props
const emit = __emit

const compareValues = (a, z) => JSON.stringify(a ?? null) === JSON.stringify(z ?? null)

const selectedOption = computed(() =>
  (props.options ?? []).find(option => compareValues(option.value, props.modelValue))
)

const buttonLabel = computed(() => selectedOption.value?.name ?? props.placeholder ?? '')

const onSelect = value => {
  emit('update:modelValue', value)
  emit('change', value)
  emit('input', value)
}

return (_ctx, _cache) => {
  return (_openBlock(), _createElementBlock("div", null, [
    (props.name)
      ? (_openBlock(), _createElementBlock("label", {
          key: 0,
          for: _unref(id),
          class: "block text-sm font-medium text-gray-700 mb-1"
        }, _toDisplayString(props.name), 9, _hoisted_1))
      : _createCommentVNode("", true),
    _createVNode(_unref(Listbox), {
      "model-value": props.modelValue,
      by: compareValues,
      disabled: props.disabled,
      "onUpdate:modelValue": onSelect
    }, {
      default: _withCtx(() => [
        _createElementVNode("div", _hoisted_2, [
          _createVNode(_unref(ListboxButton), _mergeProps({
            id: _unref(id),
            ref: _unref(setReference)
          }, _ctx.$attrs, {
            "aria-describedby": _unref(id) + '-description',
            class: [
            'relative block w-full cursor-default border border-gray-300 bg-white pl-3 pr-10 text-left text-base focus:border-brand-500 focus:outline-none focus:ring-1 focus:ring-brand-500 sm:text-sm',
            props.pill ? 'rounded-full py-1.5 text-gray-700 shadow-sm hover:bg-gray-50' : 'rounded-md',
            selectedOption.value == null && 'text-gray-500 italic',
            props.disabled && 'opacity-60 cursor-not-allowed bg-gray-50',
            !props.pill && (props.slim ? 'py-1' : 'py-2')
          ]
          }), {
            default: _withCtx(() => [
              _createElementVNode("span", _hoisted_3, _toDisplayString(buttonLabel.value || ' '), 1),
              _createElementVNode("span", _hoisted_4, [
                _createVNode(_unref(ChevronUpDownIcon), {
                  class: "h-5 w-5 text-gray-400",
                  "aria-hidden": "true"
                })
              ])
            ]),
            _: 1
          }, 16, ["id", "aria-describedby", "class"]),
          (_openBlock(), _createBlock(_Teleport, { to: "body" }, [
            _createVNode(_Transition, {
              "leave-active-class": "transition ease-in duration-100",
              "leave-from-class": "opacity-100",
              "leave-to-class": "opacity-0"
            }, {
              default: _withCtx(() => [
                _createVNode(_unref(ListboxOptions), {
                  ref: _unref(setFloating),
                  style: _normalizeStyle(_unref(floatingStyles)),
                  class: "z-50 overflow-auto rounded-md bg-white py-1 text-base shadow-lg ring-1 ring-black ring-opacity-5 focus:outline-none sm:text-sm"
                }, {
                  default: _withCtx(() => [
                    (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(__props.options, (option) => {
                      return (_openBlock(), _createBlock(_unref(ListboxOption), {
                        key: JSON.stringify(option.value),
                        value: option.value,
                        disabled: option.disabled,
                        as: "template"
                      }, {
                        default: _withCtx(({ active, selected }) => [
                          _createElementVNode("li", {
                            class: _normalizeClass([
                    active ? 'bg-brand-600 text-white' : 'text-gray-900',
                    option.disabled ? 'opacity-50 cursor-not-allowed' : 'cursor-default',
                    'relative select-none py-2 pl-8 pr-4'
                  ])
                          }, [
                            _createElementVNode("span", {
                              class: _normalizeClass([selected ? 'font-semibold' : 'font-normal', 'block truncate'])
                            }, _toDisplayString(option.name), 3),
                            selected
                              ? (_openBlock(), _createElementBlock("span", {
                                  key: 0,
                                  class: _normalizeClass([
                      active ? 'text-white' : 'text-brand-600',
                      'absolute inset-y-0 left-0 flex items-center pl-2'
                    ])
                                }, [
                                  _createVNode(_unref(CheckIcon), {
                                    class: "h-5 w-5",
                                    "aria-hidden": "true"
                                  })
                                ], 2))
                              : _createCommentVNode("", true)
                          ], 2)
                        ]),
                        _: 2
                      }, 1032, ["value", "disabled"]))
                    }), 128))
                  ]),
                  _: 1
                }, 8, ["style"])
              ]),
              _: 1
            })
          ]))
        ])
      ]),
      _: 1
    }, 8, ["model-value", "disabled"]),
    (props.description)
      ? (_openBlock(), _createElementBlock("p", {
          key: 1,
          id: _unref(id) + '-description',
          class: "mt-2 text-sm text-gray-500"
        }, _toDisplayString(props.description), 9, _hoisted_5))
      : _createCommentVNode("", true)
  ]))
}
}

})